import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import '../assets/css/happyclient.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// Import required modules
import { Autoplay } from 'swiper/modules';
import API_BASE_URL from "../../helper";

export default function HappyClient() {

    const [clients, setClients] = useState([]);

    // Fetch All Client Reviews
    const fetchClientReviews = async () => {
        try {
        const response = await fetch(`${API_BASE_URL}/api/client/all`);
        const data = await response.json();
        setClients(data);
        } catch (error) {
        console.error("Failed to load clients", error);
        }
    };

    useEffect(() => {
        fetchClientReviews();
    }, []);


  return (
    <>
        <section className='clientSection mt-5 p-lg-5 p-2'>
            <div className='container'>

                <h2 className='text-center text-white mb-4'>Happy Clients</h2>

                    <Swiper
                        slidesPerView={2}
                        spaceBetween={30}
                        autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                        }}
                        breakpoints={{
                            0: {
                            slidesPerView: 1, // Mobile
                            },
                            768: {
                            slidesPerView: 2, // Tablet & Desktop
                            }
                        }}
                        modules={[Autoplay]}
                        className="clientReviewSwiper"
                    >
                        {
                            clients.length > 0 ?
                            clients.map(client => (
                            <SwiperSlide key={client.id}>
                                <div className='clientReviewDiv p-3'>
                                <div>
                                    <p>{client.description}</p>

                                <div className='row'>
                                    <div className='col-md-8'>
                                        <div className='row'>
                                        <div className='col-md-3 col-4 clientLogoDive'>
                                            <img className='clientLogo'
                                            src={`${API_BASE_URL}/assets/Images/${client.image}`}
                                            alt='loading...'
                                            />
                                        </div>
                                        <div className='col-md-9'>
                                            <h6>{client.companyName}</h6>
                                            <p className='p-0 m-0'>{client.product}</p>
                                        </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 d-flex justify-content-end'>
                                        <div>
                                        <div>
                                            <i className="starIcon fa fa-star"></i>
                                            <i className="starIcon fa fa-star"></i>
                                            <i className="starIcon fa fa-star"></i>
                                            <i className="starIcon fa fa-star"></i>
                                            <i className="starIcon fa fa-star"></i>
                                        </div>
                                        <p><b>5.0</b> Out of 5</p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </SwiperSlide>
                            ))
                            :
                            <p className='text-white'>No Client Reviews Available</p>
                        }
                    </Swiper>

            </div>
        </section>
    </>
  );
}



